import { render, staticRenderFns } from "./VolunteerAgencies.vue?vue&type=template&id=15ec08c7&scoped=true"
import script from "./VolunteerAgencies.vue?vue&type=script&lang=js"
export * from "./VolunteerAgencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ec08c7",
  null
  
)

export default component.exports